import { Col, Row, Select, DatePicker, Button, Card } from "antd";
import { Fragment } from "react";
import { FilterOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useGetDashboardCardCommon } from "features/dashboard/use-cases/get-commonDropDown";
const { RangePicker } = DatePicker;

export const DashboardHeader = ({
  title,
  setDateRange,
  dateRange,
  setSelectedYear,
  selectedYear,
  setSelectedCategory,
  setSelectedEvent,
  selectedEvent,
  selectedCategory,
  onApplyFilters,
  chartRef,
  year
}: any) => {
  // 🔹 Get all events on first render
  const { data: eventsData } = useGetDashboardCardCommon({
    Flag: "events",
    year:year
  });
  // 🔹 Get categories based on selected event
  const { data: categoriesData } = useGetDashboardCardCommon(
    selectedEvent
      ? { Flag: "Categories", searchId: selectedEvent }
      : { enabled: false }
  );

  const today = dayjs();
  const currentYear = today.year();
  
  const years = Array.from({ length: 16 }, (_, i) => {
    const year1 = currentYear - 10 + i;

    return { label: year1.toString(), value: year1 };
  });

  const titleHeaderMap: Record<string, string> = {
    "executive-summary": "Executive Summary",
    "registration-cross-sales": "Registration & Cross Sales",
    "shop-cross-Sales-Add-ons": "Shop",
    "booth-sales": "Booth Sales",
    "financial-dashboard": "Financial Dashboard",
  };

  const displayTitle = titleHeaderMap[title] || "";

  // 🔹 Reset filters and set current date
  const handleReset = () => {
    setDateRange([today.startOf("day"), today.endOf("day")]); // ✅ set today's date
    setSelectedYear(currentYear);
    setSelectedEvent(null);
    setSelectedCategory(null);
    const chart = chartRef?.current?.chart;
    if (chart?.drillUp) {
      while (chart.drilldownLevels?.length) {
        chart.drillUp();
      }
    }
  };

  return (
    <Fragment>
      <Row align="middle" justify="space-between">
        {/* Dashboard Title */}
        <Col span={24}>
          <h2 style={{ fontSize: "16px", fontWeight: "500" }}>{displayTitle}</h2>
        </Col>
        <Card className="filtr_card filt_repn">

          {/* Filters Row */}
          <Col span={24} style={{ padding: '0' }}>
            {/* Date Range Picker */}
            <RangePicker
              allowClear
              style={{ marginRight: 16 }}
              value={dateRange}
              onChange={(dates) => {
                if (!dates) {
                  // 🔹 User cleared the date
                  setDateRange(null);

                  // 🔹 Reset drilldown on clear
                  const chart = chartRef?.current?.chart;
                  if (chart?.drillUp) {
                    while (chart.drilldownLevels?.length) {
                      chart.drillUp();
                    }
                  }

                  return;
                }

                // 🔹 Normal date selection
                setDateRange(dates as [dayjs.Dayjs, dayjs.Dayjs]);

                // 🔹 Reset drilldown whenever dates change
                const chart = chartRef?.current?.chart;
                if (chart?.drillUp) {
                  while (chart.drilldownLevels?.length) {
                    chart.drillUp();
                  }
                }
              }}
            />
            {/* Year Dropdown */}
            <Select
              options={years}
              value={selectedYear}
              onChange={(value) => {
                setSelectedYear(value);
                setDateRange(null);
              }}
              style={{ width: 140, marginRight: 16 }}
              placeholder="Select Year"
            />

            {/* Event Filter */}
            {/* Event Filter */}
            <Select
              showSearch
              placeholder="Filter by Event"
              value={selectedEvent}
              onChange={(value) => {
                setSelectedEvent(value);
                setSelectedCategory(undefined);
              }}
              style={{ width: 180, marginRight: 16 }}
              allowClear
              optionFilterProp="label"
              dropdownRender={(menu) => (
                <div>
                  <div
                    style={{
                      padding: 8,
                      fontWeight: 500,
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    <FilterOutlined style={{ marginRight: 6 }} />
                    Select Event
                  </div>
                  {menu}
                </div>
              )}
              options={
                eventsData?.dropDownList?.map((e: any) => ({
                  label: e.Name,
                  value: e.Id,
                })) || []
              }
            />

            {/* Category Filter */}
            <Select
              showSearch
              placeholder="Filter by Category"
              value={selectedCategory}
              onChange={(value) => setSelectedCategory(value)}
              style={{ width: 180, marginRight: 16 }}
              allowClear
              optionFilterProp="label"
              dropdownRender={(menu) => (
                <div>
                  <div
                    style={{
                      padding: 8,
                      fontWeight: 500,
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    <FilterOutlined style={{ marginRight: 6 }} />
                    Select Category
                  </div>
                  {menu}
                </div>
              )}
              options={
                categoriesData?.dropDownList?.map((c: any) => ({
                  label: c.Name,
                  value: c.Id,
                })) || []
              }
              disabled={!selectedEvent}
            />


            {/* Buttons */}
            <Button
              type="primary"
              onClick={() =>
                onApplyFilters?.({
                  selectedYear,
                  dateRange,
                  selectedEvent,
                  selectedCategory,
                })
              }
              style={{ marginRight: 8 }}
            >
              Filter
            </Button>
            <Button onClick={handleReset}>Cancel</Button>
          </Col>
        </Card>
      </Row>
    </Fragment>
  );
};
